export default [
    {
        value: "PatenteInvencao",
        text: "Patente de invenção"
    },
    {
        value: "PatenteModelo",
        text: "Patente de modelo de utilidade"
    },
    {
        value: "RegistroSoftware",
        text: "Registro de software"
    },
    {
        value: "RegistroDesenhoIndustrial ",
        text: "Registro de desenho industrial"
    },
]